import React from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Key } from 'lucide-react';

const OTPDialog = ({ 
  ride, 
  otpType, 
  otpCode, 
  setOtpCode, 
  verifyingOTP, 
  onVerify, 
  onClose 
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <Card className="p-6 max-w-md w-full mx-4">
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center">
              <Key className="h-6 w-6 text-orange-600" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-900">
                {otpType === 'pickup' ? 'Pickup' : 'Delivery'} OTP Required
              </h2>
              <p className="text-sm text-gray-600">
                {otpType === 'pickup' 
                  ? 'Get OTP from sender to pick up package'
                  : 'Get OTP from receiver to complete delivery'
                }
              </p>
            </div>
          </div>

          {ride.type === 'delivery' && (
            <div className="bg-blue-50 p-3 rounded-lg text-sm">
              <p className="font-medium text-blue-900">Contact Info:</p>
              {otpType === 'pickup' ? (
                <>
                  <p className="text-blue-800">Sender: {ride.senderName}</p>
                  <p className="text-blue-800">Phone: {ride.senderPhone}</p>
                </>
              ) : (
                <>
                  <p className="text-blue-800">Receiver: {ride.receiverDetails?.name}</p>
                  <p className="text-blue-800">Phone: {ride.receiverDetails?.phone}</p>
                </>
              )}
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Enter {otpType === 'pickup' ? 'Pickup' : 'Delivery'} OTP
            </label>
            <input
              type="text"
              maxLength={6}
              value={otpCode}
              onChange={(e) => setOtpCode(e.target.value.replace(/\D/g, ''))}
              placeholder="000000"
              className="w-full px-4 py-3 text-center text-2xl font-mono border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
              autoFocus
            />
          </div>

          <div className="flex gap-3">
            <Button
              onClick={onClose}
              variant="outline"
              className="flex-1"
              disabled={verifyingOTP}
            >
              Cancel
            </Button>
            <Button
              onClick={onVerify}
              className="flex-1 bg-orange-600 hover:bg-orange-700"
              disabled={verifyingOTP || otpCode.length !== 6}
            >
              {verifyingOTP ? 'Verifying...' : 'Verify OTP'}
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default OTPDialog;
